import { Button } from '@connected/ui/components/button';
import { cn } from '@connected/ui/lib/utils';
import { Link, useLocation } from '@tanstack/react-router';
import { List, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import SearchInput from './search-input';

export type CustomerLocationsHeaderProps = {
    // HACK: any type should be replaced with the correct type, that we don't know for now
    route: any;
};

export function CustomerLocationsHeader({ route }: CustomerLocationsHeaderProps) {
    const { t } = useTranslation('customer-locations');

    const location = useLocation();
    const search = route.useSearch();

    const isListViewActive
        = location.pathname.startsWith('/customer/locations/')
            && location.pathname !== '/customer/locations/';

    return (
        <div className="mb-6">
            <div className="flex max-sm:flex-wrap gap-1 md:gap-4 justify-start">
                <h1 className="text-2xl font-semibold me-auto">
                    {t('locations.header.title')}
                </h1>
                <SearchInput route={route} />
                <div className="flex justify-center items-center order-3 max-sm:order-1 max-sm:ms-auto">
                    <Button
                        variant="secondary"
                        className="flex items-center border rounded-lg rounded-r-none w-fit bg-background-primary text-foreground hover:bg-background-secondary px-3"
                        asChild
                    >
                        <Link
                            to="/customer/locations"
                            search={{ search: search.search || undefined }}
                            activeOptions={{
                                includeSearch: false,
                                exact: true,
                            }}
                            activeProps={{
                                className: 'bg-background-secondary',
                            }}
                        >
                            <MapPin className="w-5 h-5" />
                        </Link>
                    </Button>
                    <Button
                        variant="secondary"
                        className="flex items-center border rounded-lg rounded-l-none w-fit bg-background-primary text-foreground hover:bg-background-secondary px-3"
                        asChild
                    >
                        <Link
                            to="/customer/locations/electrical"
                            search={{ search: search.search || undefined }}
                            activeOptions={{
                                includeSearch: false,
                            }}
                            className={cn({
                                'bg-background-secondary': isListViewActive,
                            })}
                        >
                            <List className="w-5 h-5" />
                        </Link>
                    </Button>
                </div>
            </div>
        </div>
    );
}
